module.exports = __webpack_public_path__ + "static/media/accordion.f12b8d0b.svg";